import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../../Box/Box.js';
import { Image as ImageMemoized } from '../../Image/Image.js';
import { Typography } from '../../Typography/Typography.js';
import { IconWrapper } from './IconWrapper.js';
import { labelColorToken, isIcon } from './InputHelper.js';

var _excluded = ["state", "value", "placeholder", "leadingAsset", "trailingAsset"];

/**
 * Input skeleton component for use with Dropdown, marked up as a button.
 */
var ButtonInputSkeleton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var state = _ref.state,
    value = _ref.value,
    placeholder = _ref.placeholder,
    leadingAsset = _ref.leadingAsset,
    trailingAsset = _ref.trailingAsset,
    rest = _objectWithoutProperties(_ref, _excluded);
  var disabled = state === 'disabled';
  var textColor = disabled ? 'base.disabled' : 'deprecated.secondary.interactive';
  var placeholderColor = labelColorToken[disabled ? 'disabled' : 'default'];
  var leading = React.useMemo(function () {
    return leadingAsset && /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      borderWidth: "0",
      cursor: disabled ? 'auto' : 'text',
      whiteSpace: "nowrap",
      alignItems: "center",
      pe: "8"
    }, isIcon(leadingAsset) ? /*#__PURE__*/React.createElement(IconWrapper, {
      id: leadingAsset.id,
      color: textColor,
      size: "16"
    }) : /*#__PURE__*/React.createElement(Box, {
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(ImageMemoized.Decorative, {
      requestWidth: 24,
      src: leadingAsset.src,
      width: "24px",
      maxWidth: "24px",
      maxHeight: "24px"
    })));
  }, [disabled, leadingAsset, textColor]);
  var trailing = React.useMemo(function () {
    return trailingAsset && /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center",
      pointerEvents: "none",
      position: "absolute",
      height: "100%",
      role: "presentation",
      end: 0,
      cursor: "auto",
      pe: "16",
      py: "12"
    }, /*#__PURE__*/React.createElement(IconWrapper, {
      id: trailingAsset.id,
      color: textColor,
      size: "16"
    }));
  }, [textColor, trailingAsset]);
  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    ref: ref,
    as: "button",
    display: "flex",
    position: "relative",
    width: "100%",
    alignItems: "center",
    p: "16",
    cursor: disabled ? 'auto' : undefined,
    pointerEvents: disabled ? 'none' : undefined,
    disabled: disabled,
    className: 'ads-button-input'
  }), leading, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flex: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s",
    textColor: value ? textColor : placeholderColor
  }, value || placeholder)), trailing);
});
var ButtonInputSkeletonMemoized = /*#__PURE__*/React.memo(ButtonInputSkeleton);
ButtonInputSkeletonMemoized.displayName = 'ButtonInputSkeleton';

export { ButtonInputSkeletonMemoized as ButtonInputSkeleton };
//# sourceMappingURL=ButtonInputSkeleton.js.map
